import './Footer.css'
function Footer() {
  return (
    <footer className="footer">
            
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
        <h1 className="footer-heading"> © 2026 Green Power Tech. All rights reserved.</h1>
     <p className="footer-para">123 Sambhava Nagar, Hyderabad, Telangana, India.</p>
     </div>
     </div>
     </div>
    
    </footer>
  );
}

export default Footer;
